import React from 'react';
import { AgentInputBox } from '../agent/AgentInputBox';
import { CanvasGallery } from '../canvas/CanvasGallery';
import { PromoCarousel } from '../promo/PromoCarousel';
import type { Workflow, Project } from '../../../types';
import type { PromoItem } from '../promo/PromoCard';
import type { PendingSkillMeta } from '@/hooks/home/useAgentInput';

interface HomeSectionProps {
  promoItems: PromoItem[];
  workflows: Workflow[];
  projects?: Project[];
  onAgentSend: (value: string, skill?: PendingSkillMeta) => void;
  onSelectWorkflow: (id: string) => void;
  onCreateProject: () => void;
  onDeleteWorkflow: (id: string) => void;
  onRenameWorkflow: (id: string, newTitle: string) => void;
  onViewAllCanvases?: () => void;
}

export const HomeSection: React.FC<HomeSectionProps> = ({
  promoItems,
  workflows,
  projects,
  onAgentSend,
  onSelectWorkflow,
  onCreateProject,
  onDeleteWorkflow,
  onRenameWorkflow,
  onViewAllCanvases,
}) => {
  return (
    <section id="home" className="w-full pt-[120px]">
      {/* 垂直节奏对齐设计稿 1:9：banner y=120 → 问候组 y=485（间距 58）→ 输入框 y=561 → 工作组 y=757（间距 48）→ 作品TAB y=961（间距 48=WorksSection pt-12） */}
      {/* 滚动栏：由 PromoCarousel 内部根据断点自适应，外层仅做居中对齐 */}
      <div className="mb-[58px] mx-auto w-full flex justify-center overflow-hidden">
        <PromoCarousel items={promoItems} />
      </div>

      {/* 设计稿 141:2：对话框与工作组同列，内容列宽 1200（x=396，页宽 1920） */}
      <div className="mx-auto w-full max-w-[1200px] 2xl:w-[1200px] 2xl:max-w-[1200px]">
        {/* 对话框（原第1位 → 现第2位） */}
        <div className="mb-12" style={{ transform: 'translate(0px, -2px)' }}>
          <AgentInputBox onSend={onAgentSend} />
        </div>

        {/* 项目管理（原第2位 → 现第3位） */}
        <div className="mx-auto w-full">
          <CanvasGallery
            workflows={workflows}
            projects={projects}
            onSelectWorkflow={onSelectWorkflow}
            onCreateProject={onCreateProject}
            onDeleteWorkflow={onDeleteWorkflow}
            onRenameWorkflow={onRenameWorkflow}
            onViewAll={onViewAllCanvases}
            limit={3}
          />
        </div>
      </div>
    </section>
  );
};
